import { render, staticRenderFns } from "./BankLabel.vue?vue&type=template&id=45359b7a&"
import script from "./BankLabel.vue?vue&type=script&lang=js&"
export * from "./BankLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports